"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _TransactionManager_queue, _TransactionManager_paused, _TransactionManager_resumer, _TransactionManager_resolver, _TransactionManager_blockchain;
Object.defineProperty(exports, "__esModule", { value: true });
const manager_1 = __importDefault(require("./manager"));
const transaction_pool_1 = __importDefault(require("../transaction-pool"));
const promise_queue_1 = __importDefault(require("@ganache/promise-queue"));
const utils_1 = require("@ganache/utils");
const ethereum_transaction_1 = require("@ganache/ethereum-transaction");
// since our Manager needs to receive and Instantiable class with a
// consistent return type and our transaction factory can return
// any number of transaction types, we pass in this empty
// no op class to fool the Manager
class NoOp {
}
class TransactionManager extends manager_1.default {
    constructor(options, common, blockchain, base) {
        super(base, ethereum_transaction_1.TransactionFactory, common);
        _TransactionManager_queue.set(this, new promise_queue_1.default());
        _TransactionManager_paused.set(this, false);
        _TransactionManager_resumer.set(this, void 0);
        _TransactionManager_resolver.set(this, void 0);
        _TransactionManager_blockchain.set(this, void 0);
        this.fromFallback = async (transactionHash) => {
            const { fallback } = __classPrivateFieldGet(this, _TransactionManager_blockchain, "f");
            const tx = await fallback.request("eth_getTransactionByHash", [
                utils_1.Data.toString(transactionHash)
            ]);
            if (tx == null)
                return null;
            const blockHash = utils_1.Data.from(tx.blockHash, 32);
            const blockNumber = utils_1.Quantity.from(tx.blockNumber);
            const index = utils_1.Quantity.from(tx.transactionIndex);
            // don't get the transaction if the requested transaction is _after_ our
            // fallback's blocknumber because it doesn't exist in our local chain.
            if (!fallback.isValidForkBlockNumber(blockNumber))
                return null;
            return (0, ethereum_transaction_1.serializeRpcForDb)(tx, blockHash, blockNumber, index);
        };
        /**
         * Resume processing transactions. Has no effect if not paused.
         */
        this.resume = () => {
            if (!__classPrivateFieldGet(this, _TransactionManager_paused, "f"))
                return;
            __classPrivateFieldSet(this, _TransactionManager_paused, false, "f");
            __classPrivateFieldGet(this, _TransactionManager_resolver, "f").call(this);
        };
        __classPrivateFieldSet(this, _TransactionManager_blockchain, blockchain, "f");
        this.transactionPool = new transaction_pool_1.default(options, blockchain);
    }
    async getRaw(transactionHash) {
        return super.getRaw(transactionHash).then(block => {
            if (block == null && __classPrivateFieldGet(this, _TransactionManager_blockchain, "f").fallback) {
                return this.fromFallback(transactionHash);
            }
            return block;
        });
    }
    async get(key) {
        const factory = (await super.get(key));
        if (!factory)
            return null;
        return factory.tx;
    }
    /**
     * Adds the transaction to the transaction pool.
     *
     * Returns a promise that is only resolved in the order it was added.
     *
     * @param transaction -
     * @param secretKey -
     * @returns `true` if the `transaction` is immediately executable, `false` if
     * it may be valid in the future. Throws if the transaction is invalid.
     */
    async add(transaction, secretKey) {
        if (__classPrivateFieldGet(this, _TransactionManager_paused, "f")) {
            await __classPrivateFieldGet(this, _TransactionManager_resumer, "f");
        }
        // Because ganache requires determinism, we can't allow varying IO times to
        // potentially affect the order in which transactions are inserted into the
        // pool, so we use a FIFO queue to _return_ transaction insertions in the
        // order the were received.
        const insertion = this.transactionPool.prepareTransaction(transaction, secretKey);
        const result = await __classPrivateFieldGet(this, _TransactionManager_queue, "f").add(insertion);
        if (result) {
            this.transactionPool.drain();
        }
        return result;
    }
    /**
     * Immediately ignores all transactions that were in the process of being
     * added to the pool. These transactions' `push` promises will be resolved
     * immediately with the value `false` and will _not_ be added to the pool.
     *
     * Also clears all transactions that were already added to the pool.
     *
     * Transactions that are currently in the process of being mined may still be
     * mined.
     */
    clear() {
        __classPrivateFieldGet(this, _TransactionManager_queue, "f").clear(false);
        this.transactionPool.clear();
    }
    /**
     * Stop processing _new_ transactions; puts new requests in a queue. Has no
     * affect if already paused.
     */
    async pause() {
        if (!__classPrivateFieldGet(this, _TransactionManager_paused, "f")) {
            // stop processing new transactions immediately
            __classPrivateFieldSet(this, _TransactionManager_paused, true, "f");
            __classPrivateFieldSet(this, _TransactionManager_resumer, new Promise(resolve => {
                __classPrivateFieldSet(this, _TransactionManager_resolver, resolve, "f");
            }), "f");
        }
        // then wait until all async things we were already processing are done
        // before returning
        if (__classPrivateFieldGet(this, _TransactionManager_queue, "f").isBusy()) {
            await __classPrivateFieldGet(this, _TransactionManager_queue, "f").emit("idle");
        }
    }
}
_TransactionManager_queue = new WeakMap(), _TransactionManager_paused = new WeakMap(), _TransactionManager_resumer = new WeakMap(), _TransactionManager_resolver = new WeakMap(), _TransactionManager_blockchain = new WeakMap();
exports.default = TransactionManager;
//# sourceMappingURL=transaction-manager.js.map